import { Utils } from './utils';

// ================================================================
// スライダー機能
// ================================================================

// -----------------------------------------------
// FVスライダー初期化
// -----------------------------------------------
export function initFvSlider() {
  const element = document.querySelector('.js-fv-slider');

  if (!element) {
    return;
  }

  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded');
    return;
  }

  try {
    new Swiper('.js-fv-slider', {
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      speed: 2800,
      allowTouchMove: false,
      autoplay: {
        delay: 2400,
        disableOnInteraction: false,
      },
    });
  } catch (error) {
    console.error('Failed to initialize FV slider:', error);
  }
}

